
interface IProps {
  width?: number;
  height?: number;
  color?: string;
}

export const FilledTrashIcon = ({width=10, height=14, color="#4E4B66"}: IProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.22266 2.77832H8.77821V11.7783C8.77821 12.3306 8.3305 12.7783 7.77821 12.7783H2.22266C1.67037 12.7783 1.22266 12.3306 1.22266 11.7783V2.77832Z" fill={color} stroke={color}/>
      <path d="M7 2.77832L3 2.77832L3 2.22276C3 1.67048 3.44772 1.22276 4 1.22276L6 1.22276C6.55228 1.22276 7 1.67048 7 2.22276L7 2.77832Z" stroke={color}/>
      <path d="M0.111328 2.77832H9.88911" stroke={color}/>
    </svg>

  )
}